<template>
  <div>
    <b-modal
      id="detail-overtime-modal"
      no-close-on-backdrop
      size="lg"
      title="Detail Lembur"
    >
      <b-row>
        <b-col cols="12" xl="12">
          <table class="table table-bordered table-sm table-striped">
            <tbody>
              <tr>
                <th><span class="font-weight-bold">Nama Karyawan</span></th>
                <td>{{ result.employee ? result.employee.fullName : "-" }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Tgl</span></th>
                <td>{{ result.overtimeDate }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Mulai</span></th>
                <td>{{ result.startTime }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Selesai</span></th>
                <td>{{ result.endTime }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Total Jam Lembur</span></th>
                <td>{{ MinutesToHour(result.countTime) }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Status</span></th>
                <td>{{ result.statusApproval }}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { BCol, BAvatar, BRow } from "bootstrap-vue";

export default {
  components: {
    BCol,
    BAvatar,
    BRow,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ["result"],
  methods: {
      /**
       * @return {string}
       */
      MinutesToHour(minutes) {
        window.console.log(minutes);
        let hour = Math.floor(minutes / 60);
        let totalMinutes = minutes % 60
        let titleHours = '';
        let titleMinutes = '';
        let showMinute = '';
        let showHour = '';
        if (hour >= 1) {
            titleHours = 'Jam';
            showHour = hour;
        }
        if (totalMinutes >= 1) {
            titleMinutes = 'Menit';
            showMinute = totalMinutes;
        }
        return `${showHour} ${titleHours} ${showMinute} ${titleMinutes}`;
      }
  }
};
</script>
